import { FC, useMemo } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { chain, times } from 'lodash';
import useLinhaTempoStore from '../../store';
import ViewModeHeader, { ViewModeHeaderItem } from '../header';
import Row from './row';

const TableBody: FC<{ dates: Dayjs[] }> = ({ dates }) => {
  const itens = useLinhaTempoStore((store) => store.itens);

  const rows = useMemo(
    () =>
      chain(itens)
        .groupBy('talhao.uuid')
        .map((groupedItens) => ({
          talhao: groupedItens[0].talhao,
          itens: groupedItens,
        }))
        .sortBy('talhao.descricao')
        .value(),
    [itens],
  );

  if (!rows.length) {
    return (
      <tbody>
        <tr className="common">
          <td colSpan={dates.length + 1} className="text-center pb-2">
            Nenhum registro encontrado.
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {rows.map((row, index) => (
        <Row
          key={row.talhao.uuid}
          dates={dates}
          talhao={row.talhao}
          itens={row.itens}
          index={index}
        />
      ))}
    </tbody>
  );
};

const CurrentWeekTable = () => {
  const dates = useMemo(() => {
    const initialDate = dayjs().startOf('week');
    const weekDays = 7;

    return times(weekDays, (weekDay) => initialDate.add(weekDay, 'days'));
  }, []);

  const headerItens = useMemo(() => {
    const today = new Date();

    return dates.map<ViewModeHeaderItem>((date) => {
      const isCurrentDate = date.isSame(today, 'day');

      return {
        key: date.unix(),
        title: date.format('DD MMM'),
        current: isCurrentDate,
        subtitle: isCurrentDate ? 'Hoje' : undefined,
      };
    });
  }, [dates]);

  return (
    <div className="view-mode">
      <table>
        <ViewModeHeader itens={headerItens} />
        <TableBody dates={dates} />
      </table>
    </div>
  );
};

export default CurrentWeekTable;
